import { render, staticRenderFns } from "./DrugManuEdit.vue?vue&type=template&id=e08defd0&scoped=true"
import script from "./DrugManuEdit.vue?vue&type=script&lang=js"
export * from "./DrugManuEdit.vue?vue&type=script&lang=js"
import style0 from "./DrugManuEdit.vue?vue&type=style&index=0&id=e08defd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e08defd0",
  null
  
)

export default component.exports